import { render, staticRenderFns } from "./OrDivider.vue?vue&type=template&id=526f8756&scoped=true&"
import script from "./OrDivider.vue?vue&type=script&lang=js&"
export * from "./OrDivider.vue?vue&type=script&lang=js&"
import style0 from "./OrDivider.vue?vue&type=style&index=0&id=526f8756&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526f8756",
  null
  
)

export default component.exports